export default "__VITE_ASSET__D4Gut49A__"